import ResultsAnalysisListStore from './results.list';

export const resultsAnalysis = {
  list: ResultsAnalysisListStore
};
